document.addEventListener('DOMContentLoaded', () => {

  const sticky = document.querySelector('[data-sticky-atc]');
  if (!sticky) return;

  const mainForm = document.querySelector('product-form form');
  const mainButton = document.querySelector('[data-js-product-add-to-cart]');
  const variantContainer = document.querySelector('[data-js-product-variant-container="radio"], [data-js-product-variant-container="select"]');
  const priceContainer = document.querySelector('[data-js-product-price-compact] .product-price--original');

  const stickyBtn = sticky.querySelector('[data-sticky-add-to-cart]');
  const stickyVariants = sticky.querySelector('[data-sticky-variants]');
  const badgeEl = sticky.querySelector('[data-sticky-badge]');


  if (variantContainer && stickyVariants && variantContainer.querySelectorAll('input, option').length > 1) {
    const clone = variantContainer.cloneNode(true);

    if (clone.querySelector('input[type="radio"]')) {
      const select = document.createElement('select');

      clone.querySelectorAll('input').forEach(input => {
        const option = document.createElement('option');
        option.value = input.value;
        const label = input.dataset.shortText
        // const originalLabel = input.closest('.product-variant__item')?.querySelector('.variant-ribbon');  
        // const badge = originalLabel ? originalLabel.textContent.trim() : '';
        option.textContent = label;

        if (input.checked) option.selected = true;
        select.appendChild(option);
      });

      clone.innerHTML = '';
      clone.appendChild(select);
    }

    stickyVariants.appendChild(clone);

    stickyVariants.addEventListener('change', (e) => {
      const value = e.target.value;

      const originalInput = document.querySelector(
        `[data-js-product-variant-container] input[value="${value}"], 
         [data-js-product-variant-container] option[value="${value}"]`
      );

      if (originalInput) {
        if (originalInput.type === 'radio') {
          originalInput.checked = true;
        } else {
          originalInput.selected = true;
        }

        originalInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  const updatePrice = () => {
    if (!priceContainer) return;

    const priceText = priceContainer.textContent.trim();
    const stickyText = stickyBtn.querySelector('.sticky-atc__text');
    if (stickyText) {
      stickyText.textContent = `Add to cart`;
    }
  };

  updatePrice();

  document.addEventListener('change', updatePrice);


  stickyBtn.addEventListener('click', () => {
    if (stickyBtn.classList.contains('loading')) return;

    stickyBtn.classList.add('loading');

    mainButton.click();
    });

  const updateBadge = () => {
    const selected = document.querySelector('[data-js-product-variant-container] input:checked');

    if (!selected) return;

    const label = selected.closest('.product-variant__item');
    const ribbon = label?.querySelector('.variant-ribbon');

    if (ribbon && badgeEl) {
        badgeEl.textContent = ribbon.textContent.trim();
        badgeEl.style.display = 'inline-block';
    } else if (badgeEl) {
        badgeEl.style.display = 'none';
    }
  };


  updateBadge();
  document.addEventListener('change', updateBadge);

   const syncStickyFromOriginal = () => {
    if (!stickyVariants) return;

    const stickySelect = stickyVariants.querySelector('select');
    if (!stickySelect) return;

    // Get selected variant from original
    const selectedRadio = document.querySelector('[data-js-product-variant-container] input:checked');
    const selectedSelect = document.querySelector('[data-js-product-variant-container="select"] select');

    let value = null;

    if (selectedRadio) {
        value = selectedRadio.value;
    } else if (selectedSelect) {
        value = selectedSelect.value;
    }

    if (!value) return;

    // Update sticky select WITHOUT triggering loop
    if (stickySelect.value !== value) {
        stickySelect.value = value;
    }
  };

  document.addEventListener('change', (e) => {
    if (e.target.closest('[data-js-product-variant-container]')) {
        syncStickyFromOriginal();
    }
  });


  const observer = new IntersectionObserver(
    ([entry]) => {
      sticky.classList.toggle('active', !entry.isIntersecting);
    },
    { threshold: 0 }
  );

  observer.observe(mainButton);

  const loadingObserver = new MutationObserver(() => {
  const isLoading = mainButton.classList.contains('working');

    if (!isLoading) {
        stickyBtn.classList.remove('loading');
    }
  });

  loadingObserver.observe(mainButton, {
    attributes: true,
    attributeFilter: ['class']
  });

});